<template>
  <b-tabs pills card :vertical="!isMobileViewport" class="inc-cpt-detail-all">
    <b-tab :active="tabActive=='products'" v-if="configTabs.products">
      <template #title>
        <AppIcon name="upc-scan" label="Productos" font-scale="1.5" />
      </template>
      <b-card-text>
        <DetailProducts :customer_id="customer_id" 
                        :price_list_id="price_list_id"
                        :reason_id="reason_id"
                        :disable-customer-price-list-fallback="disableCustomerPriceListFallback"
                        @load-detail="loadProducts($event)" 
                        :detailEdit="detail.products"
                        :editPrice="editPrice"
                        :validStock="false"
                        :showDiscount="true"
                        :onlyDiscount="onlyDiscountProduct"
                        :key="'detailInvoiceProducts_' + forceUpdate"
                        :forceUpdate="forceUpdate"
                        :validItemDuplicated="validItemDuplicatedProduct"
                        :barcodeAddAutomatic="barcodeAddAutomaticProduct"
                        :barcodeConfirm="barcodeConfirmProduct"
                        :methodPayment="methodPayment"/>
      </b-card-text>
    </b-tab>

    <b-tab :active="tabActive=='productsCompound'" v-if="configTabs.productsCompound">
      <template #title>
        <AppIcon name="puzzle" label="Productos Compuestos" font-scale="1.5" />
      </template>
      <b-card-text>
        <DetailProductsCompound :customer_id="customer_id" 
                                :price_list_id="price_list_id"
                                :disable-customer-price-list-fallback="disableCustomerPriceListFallback"
                                @load-detail="loadProductsCompound($event)" 
                                :detailEdit="detail.productsCompound"
                                :editPrice="editPrice"
                                :validStock="false"
                                :showDiscount="true"
                                :key="'detailInvoiceProductsCompound_' + forceUpdate"
                                :forceUpdate="forceUpdate"
                                :validItemDuplicated="validItemDuplicatedProduct"/>
      </b-card-text>
    </b-tab>

    <b-tab :active="tabActive=='services'" v-if="configTabs.services">
      <template #title>
        <AppIcon name="design_services" label="Servicios" font-scale="1.5" />
      </template>
      <b-card-text>
        <DetailServices :customer_id="customer_id" 
                        :price_list_id="price_list_id"  
                        :disable-customer-price-list-fallback="disableCustomerPriceListFallback"
                        @load-detail="loadServices($event)"
                        :details="detail.services"                                                
                        :isEdit="true"
                        :isInvoice="true"
                        :date_init="moment().format('MM-DD-YYYY')"
                        :key="'detailInvoiceServices_' + forceUpdate"
                        :forceUpdate="forceUpdate"/>        
      </b-card-text>
    </b-tab>
    
    <b-tab :active="tabActive=='concepts'" title="Conceptos" v-if="!hideConcepts">
      <template #title>
        <AppIcon name="list-ul" label="Conceptos" font-scale="1.5" />
      </template>
      <b-card-text>
        <DetailConcepts :customer_id="customer_id" 
                        @load-detail="loadConcepts($event)"                        
                        :details="detail.concepts"             
                        :isEdit="true"
                        :key="'detailInvoiceConcepts_' + forceUpdate"
                        :forceUpdate="forceUpdate"
                        :validItemDuplicated="validItemDuplicatedConcept"/>     
      </b-card-text>
    </b-tab>
  </b-tabs>  
</template>
<script>
  import Session from '@/handler/session'
  import Profiles from '@/config/profiles'
  import Modules from '@/config/modules'
  import DetailProducts from '@/components/inc/cpbtDetail/detailProducts'  
  import DetailProductsCompound from '@/components/inc/cpbtDetail/detailProductsCompound'  
  import DetailServices from '@/components/inc/cpbtDetail/detailServices'  
  import DetailConcepts from '@/components/inc/cpbtDetail/detailConcepts'  
  import moment from 'moment'
  import Helper from '@/handler/helper'
  import Param from '@/config/parameters'

  export default {
    props: {
      customer_id:{
        type: Number,
        required: true,
      },
      price_list_id:{
        type: Number,
        default: 0,
      },   
      reason_id: {
        type: Number,
        default: 0,        
      },
      disableCustomerPriceListFallback: {
        type: Boolean,
        default: false,
      },
      detailProducts:{
        type: [Object, Array],
        default: () => [],
      },      
      detailProductsCompound:{
        type: [Object, Array],
        default: () => [],
      },            
      detailServices:{
        type: [Object, Array],
        default: () => [],
      },      
      detailConcepts:{
        type: [Object, Array],
        default: () => [],
      },        
      hideConcepts: {
        type: Boolean,
        default: true,
      },
      onlyDiscountProduct: {
        type: Boolean,
        default: false,        
      },    
      forceUpdate: {
        type: Number,
        default: 0,
      },    
      validItemDuplicatedProduct: {
        type: Boolean,
        default: true,
      },
      validItemDuplicatedConcept: {
        type: Boolean,
        default: true,
      },      
      barcodeAddAutomaticProduct: {
        type: Boolean,
        default: false,
      },
      barcodeConfirmProduct: {
        type: Boolean,
        default: false,
      },
      editPrice: {
        type: Boolean,
        default: true,        
      },
      methodPayment:{
        type: [Object, Array],
        default: () => [],
      },                     
    },
    components: {      
      DetailProducts,  
      DetailProductsCompound,
      DetailServices,
      DetailConcepts,     
    }, 
    data: () => {
      return {          
        configTabs: {
          products: false,
          productsCompound: false,
          services: false,
          concepts: false,
        },
        detail: {
          products: [],
          productsCompound: [],
          services: [],
          concepts: [],
        },      
        detailReturn: [],
        // Tabs verticales (una debajo de otra) solo en desktop; en mobile
        // pasan a horizontales (una al lado de otra), como cualquier b-tabs
        // sin el prop `vertical`.
        isMobileViewport: false,
      }
    },
    computed: {
      tabActive() {        
        if(this.configTabs.products) {
          return 'products'
        }
        if(this.configTabs.productsCompound) {
          return 'productsCompound'
        }
        if(this.configTabs.services) {
          return 'services'
        }
        if(!this.hideConcepts) {
          return 'concepts'
        }        
      },
    },
    mounted() {
      var modulesActive = Session.getSession().auth.user.permissions.modules
      
      modulesActive.forEach(element => {
        if(element.id == Modules.PRODUCTOS) {
          this.configTabs.products = true
          this.configTabs.productsCompound = Helper.hasParametersAccess(Param.P30)
        }

        if(element.id == Modules.SERVICIOS) {
          this.configTabs.services = true
        }                  
      })

      this.detail.products = this.detailProducts
      this.detail.productsCompound = this.detailProductsCompound
      this.detail.services = this.detailServices
      this.detail.concepts = this.detailConcepts

      this.mobileMql = window.matchMedia('(max-width: 767.98px)')
      this.isMobileViewport = this.mobileMql.matches
      this.mobileMql.addEventListener('change', this.updateMobileViewport)
    },
    beforeDestroy() {
      if(this.mobileMql) {
        this.mobileMql.removeEventListener('change', this.updateMobileViewport)
      }
    },
    methods: {
      updateMobileViewport(e) {
        this.isMobileViewport = e.matches
      },
      loadProducts(event) {
        this.detail.products = event
        this.$emit('load-detail-products', this.detail.products)            
      },
      loadProductsCompound(event) {        
        this.detail.productsCompound = event
        this.$emit('load-detail-products-compound', this.detail.productsCompound)            
      },      
      loadServices(event) {
        this.detail.services = event
        this.$emit('load-detail-services', this.detail.services)            
      },
      loadConcepts(event) {
        this.detail.concepts = event
        this.$emit('load-detail-concepts', this.detail.concepts)            
      }
    }     
  }
</script>
<style>
  .inc-cpt-detail-all .card-header {
    padding: 0px;
  }
  .inc-cpt-detail-all .nav-link {
    padding: 8px 6px;
  }
  .inc-cpt-detail-all > .col-auto {
    padding-left: 2px;
    padding-right: 2px;
  }
</style>
